// removed by extract-text-webpack-plugin
module.exports = {"f-h":"_3FB_1FCjTrWRpIjBPpHVSo"};


//////////////////
// WEBPACK FOOTER
// ./src/fonts/font.css
// module id = 292
// module chunks = 0